window.theme = window.theme || {};

/* Config */
theme.config = function() {
  theme.selectors = {
    $selectBtn2: '.quick_bundle',
    $plus: '.plus',
    $minus: '.minus',
    $cartBtn: '#mix_main_product',
    $counter:'#mix_counter',
    $removeBtn: '.remove_mix',
    $radio_selection:'.radio_selection',
    $adjust:'.adjust'
  }
}

/*  Init */
theme.init = function() {
  var mixBasket = [];
  var currentProductCount = 0;
  theme.config();
  theme.radio_selection(mixBasket);
  theme.plusminus(theme.selectors.$adjust);

};
theme.plusminus = function(trigger) {
$('body').on('click', trigger,function(){
  var val = 4;
  var input = $(this).parent().find('input');
  var ip = parseInt(input.val());
  if(ip == 0 && $(this).hasClass('minus')) {
    return false;
  }
  console.log($('.image-added').length);
  if ($('.image-added').length == val && $(this).hasClass('plus')){
    $('.product_main').addClass('product-disabled');
   // return false;
  }

  if($(this).hasClass('plus')) {
    ip = ip + 1;
  } else {
    $('.product_main').removeClass('product-disabled');
    ip = ip - 1;
  }
  input.val(ip);
});
}
function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

function isEmpty( el ){

     if (el.text == '' || el.text() == ' ') {
            return true;
        }            

        return false;
  }
// getUrlParameter('post');

theme.radio_selection = function(mixBasket){
  var mixBasket = [];
  var val = 4;
  $(theme.selectors.$counter).text(val);
  var  data_value="BUY 2, GET 2 FREE";
  $('#offer_text').text(data_value);
  $('.mix_counter').text(val);
  $('div#shopify-section-collection-template-mix').show();
  $('.bundle_selection').hide();
  for(var i =1; i<= val; i++){
     var cls =  '';
    if(val == 4 && i > 3){
      //cls = 'free';
    }
    $('#mix_grid').append('<div class="mix_item" data-item-index="'+ i +'"><span class="count_mix"><b>'+ i +'</b></span><div class="mix__item_blockimg '+ cls +'" style="background-image: none;"><div class="mix_overlay remove_mix"><div class="remove_icon"><svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M18.7 13V8c0-1-1-2-2-2h-1.2c-1 0-2 1-2 2v5H8c-1 0-2 1-2 2v1c0 1 1 2 2 2h5.5v5c0 1 1 2 2 2h1.2c1 0 2-1 2-2v-5h5c1.2 0 2-1 2-2v-1c0-1-.8-2-2-2h-5zM16 32C7.2 32 0 24.8 0 16S7.2 0 16 0s16 7.2 16 16-7.2 16-16 16z"></path></svg></div><span class="u-h6">Remove</span></div></div><div class="mix_info"></div></div>');
  }
  theme.addToCart2(theme.selectors.$selectBtn2,mixBasket,val);
  theme.addToCart2(theme.selectors.$plus,mixBasket,val);
  theme.removeFromCart(theme.selectors.$minus, mixBasket,val);
  theme.removeFromCart(theme.selectors.$removeBtn, mixBasket,val);
  theme.updateAjaxCart(theme.selectors.$cartBtn, mixBasket,val);
}

theme.removeFromCart = function(trigger, mixBasket,productMax) {
  $(document).on('click', trigger, function(e) {
    e.preventDefault();

    var thisVariantDataID = $(this).attr("data-variant-id");
    console.log(thisVariantDataID);
    if(trigger == '.minus'){
      var self = $(".mix_overlay[data-variant-id='"+thisVariantDataID+"']").last();
    }else{
      var self = $(this);
      $('.product_main').removeClass('product-disabled');
    }
    var idPosition = mixBasket.indexOf(thisVariantDataID);
    var item_index = $(this).parent().parent().attr('data-item-index');
    

    theme.removeImage(self);
    theme.removeInfo(self);
    theme.updateProductStatus(thisVariantDataID, "remove",productMax);
     var valDis = 4;
    
    setTimeout(function(){
      theme.total(valDis);
    },100);
    mixBasket.splice(idPosition, 1); 
    if(thisVariantDataID === '39677814505570' || thisVariantDataID === '39677814276194' || thisVariantDataID === '39677813784674'){
       
      if(item_index == 1 && item_index == 2){
        $('.Complimentary--Cartons').addClass('Complimentary--Cartons__disable');
        $('.Complimentary--Pouch').removeClass('Complimentary--Cartons__disable'); 
      }else if(item_index == 1){
        console.log(item_index);
        $('.Complimentary--Cartons').addClass('Complimentary--Cartons__disable');
        $('.Complimentary--Pouch').removeClass('Complimentary--Cartons__disable'); 
      }else if(item_index == 2){
        $('.Complimentary--Cartons').addClass('Complimentary--Cartons__disable');
        $('.Complimentary--Pouch').removeClass('Complimentary--Cartons__disable'); 
      }
       
    }
    var  count = {};
    mixBasket.forEach(function(i) { count[i] = (count[i]||0) + 1;});
    for(var i in count)
    {
      $('#product_qty_'+i).val(count[i]);
    }
  });
}
theme.removeImage = function(self) {
  $(self).closest('.mix_item').find('.mix_overlay').removeAttr("data-variant-id");
  $(self).closest('.mix_item').find('.mix__item_blockimg').css('background-image', 'none').removeClass('image-added').removeAttr('data-price');
}
theme.removeInfo = function(self) {
  $(self).closest('.mix_item').find('.mix_info').html('').removeClass('image-added').removeAttr('data-price');
}
/**/

theme.updateAjaxCart = function(trigger, mixBasket,bundle_id) {
  var pickmixID = $.now();
  $(trigger).on('click', function(e) {
    e.preventDefault();
    $('.overlay_loader').show();
    $('.mix_main_product').text('Adding...');
    console.log('Pick Mix ID '+pickmixID);
    console.log('pickMixBasket value is '+mixBasket);
    var  count = {};
    mixBasket.forEach(function(i) { 
      count[i] = (count[i]||0) + 1; 
    });
    var s = 1;
    console.log(count, count.length);

    setTimeout(function(){
    $('.mix_overlay').each(function(){
      var data_variant = $(this).attr('data-variant-id');
      var propType = 'Bundle_'+bundle_id;
      
      // Changes by CCI/Girish - Start 
      // 21-08-2019
      var isFree = $(this).parent().parent().hasClass("free") ? "Yes" : "No";		
      // Changes by CCI/Girish - End
      
      if($('.image-added').length == 4 && s > 2) {        
        var propType = 'Bundle_4 (Free)';
      } 
      jQuery.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        data: { id: data_variant, quantity: 1, properties: { 'Your Bundle ID': pickmixID, 'Bundle': propType, 'Free': isFree }},
        async: false,
        success: function(item) {
          console.log(item);
         window.location.href = "/cart";
        },
        error: function(err) {
          console.log(err);
        }
      });
      s = s+1;

    });
      $('.overlay_loader').hide();
      $('.mix_main_product').text('Added');
    },500);
  });
};
theme.total = function(perdiscount){
  var total = 0;
  var mf = '${{amount}}';
  var g = [];
  var outarray = [];
  var one ;
  var Two ;
  $('.mix__item_blockimg.image-added').each(function(i,v){
    if( i <= 1){
      total = total + Number($(this).attr('data-price'));
    }
    g.push(total);
   
  }); 
  if(perdiscount == 4){
    if(g.length == 4) {
      for(var i=0;i< 2;i++)
      {
        one = Math.min.apply(null,g); 
        outarray.push(one);
        g.splice(g.indexOf(one), 1);
      }
      Two = outarray[0] + outarray[1];
      $(".mix__item_blockimg.image-added").parent().last().addClass("free");
      $(".mix__item_blockimg.image-added").parent().last().prev().addClass("free");
      var two_item =  Two;
      var total_price = total;
      console.log(total_price);
    } else {
      console.log("no");
      $(".mix_item").removeClass("free");
      var total_price = total ;
    }
    $('#total_price').html('<span id="offer_text" class="FontWeight_Six">BUY 2, GET 2 FREE</span><span class="u-h2 FontWeight_Six">Total: '+Shopify.formatMoney(total_price ,mf)+'</span><span>View Selection</span>');
  }else{
    $(".mix_item").removeClass("free");
    $('#total_price').html('<span class="u-h2 FontWeight_Six">Total: '+Shopify.formatMoney(total ,mf)+'</span><span class="u-h1 FontWeight_Six">saving: Free shipping</span>');
  }
  var minimum =  g;
  console.log(minimum);
  
  if(total_price == 0){
    $('#total_price').hide();
  }else{
    $('#total_price').show();
  }
}

theme.addToCart2 = function(trigger, mixBasket,val) {
  var productMax = val;
  console.log(mixBasket.length);
  $("body").on('click', trigger, function(e) {
    var main = $(this), 
        imgSrc = $(this).closest('.product_main').attr('data-image'),
        title = $(this).closest('.product_main').attr('data-title'),
        price = $(this).closest('.product_main').attr('data-price'),
        thisVariantDataID = $(this).attr('data-variant-id'),
        duplicate = $.inArray(thisVariantDataID, mixBasket);
       if (mixBasket.length < productMax){
          mixBasket.push(thisVariantDataID);
          theme.updateProductStatus(thisVariantDataID,'not',productMax)
          theme.populateImage(imgSrc, thisVariantDataID,price);
          theme.populateInfo(title);
          setTimeout(function(){
            theme.total(productMax);
          },100);
         if(mixBasket.length <= 1){
            
          }else{
            $('.Complimentary--Cartons').removeClass('Complimentary--Cartons__disable'); 
          }
        
         if(mixBasket.length >= 2){
           $('.Complimentary--Pouch').addClass('Complimentary--Cartons__disable'); 
         }
         $(".mix_info").each(function() {
            var trIsEmpty = true;
            var tr = $(this);
           if($(this).is(':empty')){
             var item_index_no = $(this).parent().attr('data-item-index');
             if(item_index_no == 2){
               $('.Complimentary--Pouch').removeClass('Complimentary--Cartons__disable'); 
               $('.Complimentary--Cartons').addClass('Complimentary--Cartons__disable');
             }
           }
              
          });
         $('.max-error').remove();
        }else{
          $('.max-error').remove();
          $('.mix').addClass('pickmix--show');
          $('.mix_inner').before('<p class="max-error">Max 4 items selected. If you would like to change your selection, click the remove button below the item you would like to remove.</p>');
          }
  });
}
theme.populateImage = function(imgSrc, variantID,price) {
  $('.mix__item_blockimg').each(function(){
    if ($(this).css('background-image') === 'none')  {
      $(this).css('background-image', 'url(' + imgSrc + ')');
      $(this).find('.mix_overlay').attr("data-variant-id", variantID);
      $(this).addClass('image-added');
      $(this).attr('data-price',price);
      return false;
    }
  });
}
theme.populateInfo = function(title) {
  $('.mix_info').each(function(){
    if ( $(this).text() === "" ) {
      $(this).append('<h5 class="u-h6 FontWeight_Six">'+title+'</h5>');
      $(this).next().addClass("info_added");
      return false;
    };
  });
}
theme.updateProductStatus = function(thisVariantDataID, action,productMax) {
  if (action == "remove") {
    $(".product_main[data-variant-id='"+thisVariantDataID+"']").removeClass('is-active');
    theme.updateProductCounter("addition",productMax);
  } else {
    $(".product_main[data-variant-id='"+thisVariantDataID+"']").addClass('is-active');
    theme.updateProductCounter("subtraction",productMax);
  }
  //  theme.checkCompletion();
}
theme.updateProductCounter = function(action,productMax) {
  var productCount = theme.selectors.$counter,
      newValue = 0;
  if(theme.checkProductCounter(productCount,productMax)) {
    if (action == "addition"){
      newValue = parseInt($(productCount).text()) + 1;
    } else {
      newValue = parseInt($(productCount).text()) - 1;
    }

    $(productCount).text(newValue);
    if(newValue == 0) {
      theme.enableSubmitButtons();
    } else {
      theme.disableSubmitButtons();
    }
  }
}
theme.checkProductCounter = function(counter,productMax) {
  var currentCount = parseInt($(counter).text());
  if(currentCount >= 0 && currentCount <= productMax) {
    return true;
  }
}
theme.enableSubmitButtons = function() {
  var cartBtn = theme.selectors.$cartBtn;
  $(cartBtn).removeClass('full');
  //$(cartBtn).removeClass('disabled');
  $(cartBtn).attr("disabled", false);
}
theme.disableSubmitButtons = function() {
  var cartBtn = theme.selectors.$cartBtn;
  $(cartBtn).addClass('full');
  //$(cartBtn).addClass('disabled');
  $(cartBtn).attr("disabled", true);
}
$(theme.init);